import styled from 'styled-components'

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const FileName = styled.span`
  font-size: 1.2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray};
`

export const ContentContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`

export const ErrorItem = styled.div`
  padding: 1.2rem;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.lightRed || '#ffeaea'};
`

export const ErrorLabel = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.error || '#f44336'};
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
`

export const ErrorValue = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1.3rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
`

export const ErrorText = styled.div`
  padding: 1.2rem;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.lightRed || '#ffeaea'};
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1.3rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
`
